import { Mappable } from "../_shared/mappable.class";

export class WorkflowRun extends Mappable<WorkflowRun> {

  engineWorkflowRunId: number;
  engineId: number;
  workflowName: string;
  status: WorkflowRunStatus;
  conclusion: WorkflowRunConclusion;

  statusName: string;
  conclusionName: string;
}

export enum WorkflowRunStatus {
  Requested = 0,
  InProgress = 1,
  Completed = 2,
  Queued = 3,
  Waiting = 4
}

export enum WorkflowRunConclusion {
  Success = 0,
  Failure = 1,
  Neutral = 2,
  Cancelled = 3,
  TimedOut = 4,
  ActionRequired = 5,
  Stale = 6
}